// Generated by scripts/generate-catalogue.mjs. Do not edit.
import type { FrameSpec } from '../frames';
export type FrameEntry = FrameSpec & { thumbnail?: string };
export const FRAME_INDEX: FrameEntry[] = [
  {
    "id": "java-jungle-onyx-night-1",
    "model": "Java Jungle",
    "colorway": "Onyx Night",
    "line": "Classic",
    "productHandle": "java-jungle-onyx-night-1",
    "customizable": false,
    "dims": {
      "widthMm": 132,
      "lensWidthMm": 45,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 39.1267,
      "frontDepthMm": 4,
      "endPieceDepthMm": 3
    },
    "temple": {
      "profileMode": "measured",
      "profileStartMm": 0,
      "widthMm": 2.5,
      "tipWidthRatio": 1,
      "topInsetMm": 0,
      "hingeInsetMm": 0.7,
      "outerInsetMm": 0.15,
      "solidConnector": true,
      "topAtHingeMm": 12.36,
      "junctionHeightMm": 3.25,
      "hingeOffsetYMm": [
        -0.03,
        0.03
      ]
    },
    "fit": {
      "pantoscopicTiltDeg": 0,
      "anchorOffsetYMm": -0.29350000000000076,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#111315",
      "acetateRoughness": 0.23,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#596b75",
      "lensOpacity": 0.55,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.31,
        0.39,
        0.43
      ],
      "lensGradient": 0
    },
    "hybridMetal": {
      "color": "#c5c9cc",
      "roughness": 0.23,
      "front": [
        {
          "fromMm": -80,
          "toMm": -56.4,
          "depthMm": 1.2,
          "transitionMm": 0.4,
          "yMinMm": 8.5,
          "yMaxMm": 13.1
        },
        {
          "fromMm": -9.5,
          "toMm": 9.5,
          "depthMm": 1.2,
          "transitionMm": 0.4
        },
        {
          "fromMm": 56.4,
          "toMm": 80,
          "depthMm": 1.2,
          "transitionMm": 0.4,
          "yMinMm": 8.5,
          "yMaxMm": 13.1
        }
      ],
      "temple": [
        {
          "fromMm": -5,
          "toMm": 86.7,
          "depthMm": 1.3,
          "transitionMm": 0.8
        }
      ],
      "nosePads": {
        "center": [
          8.3,
          -2.7,
          -4
        ],
        "size": [
          3.5,
          9.5,
          1.2
        ],
        "arm": [
          [
            10,
            3,
            -0.5
          ],
          [
            8.8,
            1,
            -2.7
          ],
          [
            8.3,
            -2.7,
            -4
          ]
        ],
        "armRadiusMm": 0.25,
        "rotationZRad": 0.3,
        "rotationYRad": 1,
        "rotationXRad": 0.12,
        "opacity": 0.14
      }
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-jungle-onyx-night-1-front.jpg", import.meta.url).href
  },
  {
    "id": "java-jungle-sunset-glow-1",
    "model": "Java Jungle",
    "colorway": "Sunset Glow",
    "line": "Classic",
    "productHandle": "java-jungle-sunset-glow-1",
    "customizable": false,
    "dims": {
      "widthMm": 132,
      "lensWidthMm": 45,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 38.6375,
      "frontDepthMm": 4,
      "endPieceDepthMm": 3
    },
    "temple": {
      "profileMode": "measured",
      "profileStartMm": 0,
      "widthMm": 2.5,
      "tipWidthRatio": 1,
      "topInsetMm": 0,
      "hingeInsetMm": 0.7,
      "outerInsetMm": 0.15,
      "solidConnector": true,
      "topAtHingeMm": 11.65,
      "junctionHeightMm": 3.46,
      "hingeOffsetYMm": [
        -0.3,
        0.3
      ]
    },
    "fit": {
      "pantoscopicTiltDeg": 0,
      "anchorOffsetYMm": 0.0914249999999992,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#825125",
      "acetateRoughness": 0.23,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#97723f",
      "lensOpacity": 0.52,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.53,
        0.37,
        0.2
      ],
      "lensGradient": 0
    },
    "hybridMetal": {
      "color": "#d0b47f",
      "roughness": 0.23,
      "front": [
        {
          "fromMm": -80,
          "toMm": -56.4,
          "depthMm": 1.2,
          "transitionMm": 0.4,
          "yMinMm": 7.7,
          "yMaxMm": 13.1
        },
        {
          "fromMm": -9.5,
          "toMm": 9.5,
          "depthMm": 1.2,
          "transitionMm": 0.4
        },
        {
          "fromMm": 56.4,
          "toMm": 80,
          "depthMm": 1.2,
          "transitionMm": 0.4,
          "yMinMm": 7.7,
          "yMaxMm": 13.1
        }
      ],
      "temple": [
        {
          "fromMm": -5,
          "toMm": 89.1,
          "depthMm": 1.3,
          "transitionMm": 0.8
        }
      ],
      "nosePads": {
        "center": [
          8.3,
          -2.7,
          -4
        ],
        "size": [
          3.5,
          9.5,
          1.2
        ],
        "arm": [
          [
            10,
            3,
            -0.5
          ],
          [
            8.8,
            1,
            -2.7
          ],
          [
            8.3,
            -2.7,
            -4
          ]
        ],
        "armRadiusMm": 0.25,
        "rotationZRad": 0.3,
        "rotationYRad": 1,
        "rotationXRad": 0.12,
        "opacity": 0.14
      }
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-jungle-sunset-glow-1-front.jpg", import.meta.url).href
  },
  {
    "id": "java-jungle-caramel-swirl-1",
    "model": "Java Jungle",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "java-jungle-caramel-swirl-1",
    "customizable": false,
    "dims": {
      "widthMm": 132,
      "lensWidthMm": 45,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 38.8719,
      "frontDepthMm": 4,
      "endPieceDepthMm": 3
    },
    "temple": {
      "profileMode": "measured",
      "profileStartMm": 0,
      "widthMm": 2.5,
      "tipWidthRatio": 1,
      "topInsetMm": 0,
      "hingeInsetMm": 0.7,
      "outerInsetMm": 0.15,
      "solidConnector": true,
      "topAtHingeMm": 11.65,
      "junctionHeightMm": 3.1,
      "hingeOffsetYMm": [
        -0.3,
        0.3
      ]
    },
    "fit": {
      "pantoscopicTiltDeg": 0,
      "anchorOffsetYMm": 0.2588000000000008,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#683a1c",
      "acetateRoughness": 0.23,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#5b7968",
      "lensOpacity": 0.5,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.31,
        0.43,
        0.35
      ],
      "lensGradient": 0
    },
    "hybridMetal": {
      "color": "#d0b47f",
      "roughness": 0.23,
      "front": [
        {
          "fromMm": -80,
          "toMm": -56.4,
          "depthMm": 1.2,
          "transitionMm": 0.4,
          "yMinMm": 7.8,
          "yMaxMm": 13.1
        },
        {
          "fromMm": -9.5,
          "toMm": 9.5,
          "depthMm": 1.2,
          "transitionMm": 0.4
        },
        {
          "fromMm": 56.4,
          "toMm": 80,
          "depthMm": 1.2,
          "transitionMm": 0.4,
          "yMinMm": 7.8,
          "yMaxMm": 13.1
        }
      ],
      "temple": [
        {
          "fromMm": -5,
          "toMm": 89.7,
          "depthMm": 1.3,
          "transitionMm": 0.8
        }
      ],
      "nosePads": {
        "center": [
          8.3,
          -2.7,
          -4
        ],
        "size": [
          3.5,
          9.5,
          1.2
        ],
        "arm": [
          [
            10,
            3,
            -0.5
          ],
          [
            8.8,
            1,
            -2.7
          ],
          [
            8.3,
            -2.7,
            -4
          ]
        ],
        "armRadiusMm": 0.25,
        "rotationZRad": 0.3,
        "rotationYRad": 1,
        "rotationXRad": 0.12,
        "opacity": 0.14
      }
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-jungle-caramel-swirl-1-front.jpg", import.meta.url).href
  },
  {
    "id": "flores-breeze-golden-hour-1",
    "model": "Flores Breeze",
    "colorway": "Golden Hour",
    "line": "Classic",
    "productHandle": "flores-breeze-golden-hour-1",
    "customizable": false,
    "dims": {
      "widthMm": 142,
      "lensWidthMm": 49,
      "bridgeMm": 21.5,
      "templeMm": 145,
      "lensHeightMm": 44.4155,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 20.2,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.9
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#d8a327",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.6,
      "acetatePhotoOpacity": 0.76,
      "rivetLengthMm": 0,
      "lensColor": "#52675d",
      "lensOpacity": 0.52,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.3,
        0.41,
        0.35
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-flores-breeze-golden-hour-1-front.jpg", import.meta.url).href
  },
  {
    "id": "flores-breeze-morning-lagoon-1",
    "model": "Flores Breeze",
    "colorway": "Morning Lagoon",
    "line": "Classic",
    "productHandle": "flores-breeze-morning-lagoon-1",
    "customizable": false,
    "dims": {
      "widthMm": 142,
      "lensWidthMm": 49,
      "bridgeMm": 21.5,
      "templeMm": 145,
      "lensHeightMm": 44.5236,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 20.2,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.9
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#62301c",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 0.99,
      "rivetLengthMm": 0,
      "lensColor": "#5c7868",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1264,
        0.172,
        0.1404
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-flores-breeze-morning-lagoon-1-front.jpg", import.meta.url).href
  },
  {
    "id": "flores-breeze-silver-mist",
    "model": "Flores Breeze",
    "colorway": "Silver Mist",
    "line": "Classic",
    "productHandle": "flores-breeze-silver-mist",
    "customizable": false,
    "dims": {
      "widthMm": 142,
      "lensWidthMm": 49,
      "bridgeMm": 21.5,
      "templeMm": 145,
      "lensHeightMm": 44.4407,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 20,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.6
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#c0bebb",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.3,
      "acetatePhotoOpacity": 0.44,
      "rivetLengthMm": 0,
      "lensColor": "#62674e",
      "lensOpacity": 0.5,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.38,
        0.41,
        0.28
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-flores-breeze-silver-mist-front.jpg", import.meta.url).href
  },
  {
    "id": "flores-breeze-sunlight-aura",
    "model": "Flores Breeze",
    "colorway": "Sunlight Aura",
    "line": "Classic",
    "productHandle": "flores-breeze-sunlight-aura",
    "customizable": false,
    "dims": {
      "widthMm": 142,
      "lensWidthMm": 49,
      "bridgeMm": 21.5,
      "templeMm": 145,
      "lensHeightMm": 44.4155,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 20,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.9
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateCrystal": true,
      "acetateColor": "#dce2e2",
      "acetateRoughness": 0.08,
      "acetateOpacity": 0.12,
      "acetatePhotoOpacity": 0.18,
      "templeAcetateColor": "#482619",
      "templeAcetateOpacity": 0.95,
      "templeAcetatePhotoOpacity": 0.99,
      "rivetLengthMm": 0,
      "lensColor": "#9c713e",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2365,
        0.1468,
        0.0653
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-flores-breeze-sunlight-aura-front.jpg", import.meta.url).href
  },
  {
    "id": "flores-breeze-olive-gove-1",
    "model": "Flores Breeze",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "flores-breeze-olive-gove-1",
    "customizable": false,
    "dims": {
      "widthMm": 142,
      "lensWidthMm": 49,
      "bridgeMm": 21.5,
      "templeMm": 145,
      "lensHeightMm": 44.2175,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 19.2,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.1
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#598969",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.58,
      "acetatePhotoOpacity": 0.73,
      "rivetLengthMm": 0,
      "lensColor": "#71a286",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1256,
        0.1721,
        0.1418
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-flores-breeze-olive-gove-1-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-morning-lagoon-1",
    "model": "Bali Blue",
    "colorway": "Morning Lagoon",
    "line": "Classic",
    "productHandle": "bali-blue-morning-lagoon-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 34.1704,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.5,
      "topAtHingeMm": 15.5,
      "profileHeightMm": 16,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#42271f",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-morning-lagoon-1-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-dark-forest-1",
    "model": "Bali Blue",
    "colorway": "Dark Forest",
    "line": "Classic",
    "productHandle": "bali-blue-dark-forest-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 34.1753,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.5,
      "topAtHingeMm": 15.5,
      "profileHeightMm": 16,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#35271f",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#e2a756",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2332,
        0.1494,
        0.0498
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-dark-forest-1-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-olive-gove-json",
    "model": "Bali Blue",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "bali-blue-olive-gove-json",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 34.0922,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.5,
      "topAtHingeMm": 15.5,
      "profileHeightMm": 16,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#526f51",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-olive-gove-json-front.jpg", import.meta.url).href
  },
  {
    "id": "borneo-bliss-olive-gove-1",
    "model": "Borneo Bliss",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "borneo-bliss-olive-gove-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 40.4767,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 20.8,
      "profileHeightMm": 11.6,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#667b60",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.9,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-borneo-bliss-olive-gove-1-front.jpg", import.meta.url).href
  },
  {
    "id": "borneo-bliss-dark-forest-1",
    "model": "Borneo Bliss",
    "colorway": "Dark Forest",
    "line": "Classic",
    "productHandle": "borneo-bliss-dark-forest-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 40.6596,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 20.5,
      "profileHeightMm": 11.4,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#392719",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#80caef",
      "lensOpacity": 0.28,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.43,
        0.74,
        0.92
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-borneo-bliss-dark-forest-1-front.jpg", import.meta.url).href
  },
  {
    "id": "borneo-bliss-charcoal-cloud-1",
    "model": "Borneo Bliss",
    "colorway": "Charcoal Cloud",
    "line": "Classic",
    "productHandle": "borneo-bliss-charcoal-cloud-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 39.2178,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 21.5,
      "profileHeightMm": 11.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#8da7aa",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.83,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#a0d4ea",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1208,
        0.1687,
        0.1895
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-borneo-bliss-charcoal-cloud-1-front.jpg", import.meta.url).href
  },
  {
    "id": "gili-escape-amber-sun-1",
    "model": "Gili Escape",
    "colorway": "Amber Sun",
    "line": "Classic",
    "productHandle": "gili-escape-amber-sun-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 44.0029,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 12.9,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 7.2
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#a54514",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.76,
      "acetatePhotoOpacity": 0.88,
      "rivetLengthMm": 0,
      "lensColor": "#f6b5a0",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2024,
        0.1503,
        0.1315
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gili-escape-amber-sun-1-front.jpg", import.meta.url).href
  },
  {
    "id": "gili-escape-olive-gove",
    "model": "Gili Escape",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "gili-escape-olive-gove",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 44.1077,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 12.9,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 7.8
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#578459",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.68,
      "acetatePhotoOpacity": 0.8,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gili-escape-olive-gove-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-midnight-sky",
    "model": "Bali Blue",
    "colorway": "Midnight Sky",
    "line": "Classic",
    "productHandle": "bali-blue-midnight-sky",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 33.0935,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 15.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 16
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.8,
      "frontPhotoUniformBelowMm": [
        5,
        2
      ],
      "acetateColor": "#08090b",
      "acetateRoughness": 0.17,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#a6c7d6",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.135,
        0.1655,
        0.1786
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-midnight-sky-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-mystic-mauve-1",
    "model": "Bali Blue",
    "colorway": "Mystic Mauve",
    "line": "Classic",
    "productHandle": "bali-blue-mystic-mauve-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 34.2903,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 13.1,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 16
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.4,
      "acetateColor": "#c8a6db",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 0.94,
      "rivetLengthMm": 0,
      "lensColor": "#43585f",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1102,
        0.1566,
        0.174
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-mystic-mauve-1-front.jpg", import.meta.url).href
  },
  {
    "id": "borneo-bliss-black-sun",
    "model": "Borneo Bliss",
    "colorway": "Black Sun",
    "line": "Classic",
    "productHandle": "borneo-bliss-black-sun",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 39.704,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 12.5
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#302014",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#735033",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.33,
        0.2,
        0.11
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-borneo-bliss-black-sun-front.jpg", import.meta.url).href
  },
  {
    "id": "borneo-bliss-velvet-noir-1",
    "model": "Borneo Bliss",
    "colorway": "Velvet Noir",
    "line": "Classic",
    "productHandle": "borneo-bliss-velvet-noir-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 40.0443,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 11.6
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.5,
      "acetateColor": "#1c2530",
      "acetateRoughness": 0.19,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b2c9a8",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1418,
        0.1684,
        0.1307
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-borneo-bliss-velvet-noir-1-front.jpg", import.meta.url).href
  },
  {
    "id": "gili-escape-caramel-swirl-1",
    "model": "Gili Escape",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "gili-escape-caramel-swirl-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 44.6751,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 12.9,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 7.2
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#57321d",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.93,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gili-escape-caramel-swirl-1-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-caramel-swirl",
    "model": "Bali Blue",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "bali-blue-caramel-swirl",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 34.2727,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 15.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 16
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.4,
      "acetateColor": "#57260e",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#805326",
      "lensOpacity": 0.58,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.39,
        0.23,
        0.11
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-caramel-swirl-front.jpg", import.meta.url).href
  },
  {
    "id": "bali-blue-pink-lemonade",
    "model": "Bali Blue",
    "colorway": "Pink Lemonade",
    "line": "Classic",
    "productHandle": "bali-blue-pink-lemonade",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 33.6155,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 2.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 15.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 16
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.4,
      "acetateColor": "#98645b",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#78604a",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2119,
        0.1506,
        0.1004
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bali-blue-pink-lemonade-front.jpg", import.meta.url).href
  },
  {
    "id": "gili-escape-silver-mist",
    "model": "Gili Escape",
    "colorway": "Silver Mist",
    "line": "Classic",
    "productHandle": "gili-escape-silver-mist",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 44.664,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.8,
      "topAtHingeMm": 12.4,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 7
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#bebfc1",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.35,
      "acetatePhotoOpacity": 0.46,
      "rivetLengthMm": 0,
      "lensColor": "#55565a",
      "lensOpacity": 0.58,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.27,
        0.28,
        0.3
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gili-escape-silver-mist-front.jpg", import.meta.url).href
  },
  {
    "id": "java-joy-caramel-swirl",
    "model": "Java Joy",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "java-joy-caramel-swirl",
    "customizable": false,
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 53,
      "bridgeMm": 18.5,
      "templeMm": 145,
      "lensHeightMm": 41.4456,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.2
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#57260e",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#586357",
      "lensOpacity": 0.56,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.28,
        0.32,
        0.27
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-joy-caramel-swirl-front.jpg", import.meta.url).href
  },
  {
    "id": "java-joy-olive-gove",
    "model": "Java Joy",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "java-joy-olive-gove",
    "customizable": false,
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 53,
      "bridgeMm": 18.5,
      "templeMm": 145,
      "lensHeightMm": 41.2064,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.2
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#578459",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.68,
      "acetatePhotoOpacity": 0.8,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-joy-olive-gove-front.jpg", import.meta.url).href
  },
  {
    "id": "java-joy-velvet-noir-copy",
    "model": "Java Joy",
    "colorway": "Velvet Noir",
    "line": "Classic",
    "productHandle": "java-joy-velvet-noir-copy",
    "customizable": false,
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 53,
      "bridgeMm": 18.5,
      "templeMm": 145,
      "lensHeightMm": 41.5643,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.2
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoUniformBelowMm": [
        5,
        2
      ],
      "frontPhotoLensInsetMm": 0.8,
      "acetateColor": "#1d252b",
      "acetateRoughness": 0.19,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c78f60",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2184,
        0.1493,
        0.094
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.2682,
        0.2654,
        0.2571
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-joy-velvet-noir-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "java-joy-morning-lagoon-1",
    "model": "Java Joy",
    "colorway": "Morning Lagoon",
    "line": "Classic",
    "productHandle": "java-joy-morning-lagoon-1",
    "customizable": false,
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 53,
      "bridgeMm": 18.5,
      "templeMm": 145,
      "lensHeightMm": 41.1485,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.2
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#572a20",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c1d0d6",
      "lensOpacity": 0.16,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.7,
        0.77,
        0.8
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-java-joy-morning-lagoon-1-front.jpg", import.meta.url).href
  },
  {
    "id": "komodo-rise-olive",
    "model": "Komodo Rise",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "komodo-hills-olive-gove",
    "variantId": "gid://shopify/ProductVariant/50903385768214",
    "temple": {
      "solidConnector": true,
      "profileHeightMm": 6.5,
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 12,
      "profileMode": "reconstruct-occluded-bottom",
      "profileFitRangeMm": [
        12,
        84
      ]
    },
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 50.5,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 32.4,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#3d4a3f",
      "acetateRoughness": 0.24,
      "acetateOpacity": 0.86,
      "acetatePhotoOpacity": 0.88,
      "rivetLengthMm": 0,
      "butterflyRivets": [
        [
          -65.7,
          7.55
        ],
        [
          66,
          7.4
        ]
      ],
      "lensColor": "#1e3a2a",
      "lensOpacity": 0.5,
      "lensMirror": 0.1,
      "lensTransmission": [
        0.28,
        0.36,
        0.29
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-komodo-rise-front.jpg", import.meta.url).href
  },
  {
    "id": "cove",
    "model": "Cove",
    "colorway": "Silver Mist",
    "line": "Classic",
    "productHandle": "cove",
    "customizable": false,
    "dims": {
      "widthMm": 140,
      "lensWidthMm": 50.4,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 33.8924,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.8
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#dfddd1",
      "acetateRoughness": 0.15,
      "acetateOpacity": 0.5,
      "acetatePhotoOpacity": 0.8,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cove-front.jpg", import.meta.url).href
  },
  {
    "id": "cove-black",
    "model": "Cove",
    "colorway": "Onyx Night",
    "line": "Classic",
    "productHandle": "cove-black",
    "customizable": false,
    "dims": {
      "widthMm": 140,
      "lensWidthMm": 50.4,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 32.9492,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.8
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.5,
      "acetateColor": "#171b18",
      "acetateRoughness": 0.2,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#93998b",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1538,
        0.1634,
        0.1442
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cove-black-front.jpg", import.meta.url).href
  },
  {
    "id": "cove-tortoise",
    "model": "Cove",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "cove-tortoise",
    "customizable": false,
    "dims": {
      "widthMm": 140,
      "lensWidthMm": 50.4,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 33.406,
      "frontDepthMm": 4,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 5.8
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "frontPhotoLensInsetMm": 0.35,
      "acetateColor": "#6b4325",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.93,
      "acetatePhotoOpacity": 0.96,
      "rivetLengthMm": 0,
      "lensColor": "#d99b34",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2156,
        0.1536,
        0.0595
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cove-tortoise-front.jpg", import.meta.url).href
  },
  {
    "id": "lombok-luxe-tuxedo-tranquility-1",
    "model": "Lombok Luxe",
    "colorway": "Tuxedo Tranquility",
    "line": "Classic",
    "productHandle": "lombok-luxe-tuxedo-tranquility-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47.5,
      "bridgeMm": 22.5,
      "templeMm": 145,
      "lensHeightMm": 32.1134,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 10.3
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#958675",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.91,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#bdc6ed",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.1509,
        0.1594,
        0.1933
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-lombok-luxe-tuxedo-tranquility-1-front.jpg", import.meta.url).href
  },
  {
    "id": "lombok-luxe-midnight-sky-1",
    "model": "Lombok Luxe",
    "colorway": "Midnight Sky",
    "line": "Classic",
    "productHandle": "lombok-luxe-midnight-sky-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47.5,
      "bridgeMm": 22.5,
      "templeMm": 145,
      "lensHeightMm": 32.3454,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 10.3
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#222a32",
      "acetateRoughness": 0.2,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#99b68e",
      "lensOpacity": 0.62,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.139,
        0.1696,
        0.1272
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-lombok-luxe-midnight-sky-1-front.jpg", import.meta.url).href
  },
  {
    "id": "lombok-luxe-black-sun-1",
    "model": "Lombok Luxe",
    "colorway": "Black Sun",
    "line": "Classic",
    "productHandle": "lombok-luxe-black-sun-1",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47.5,
      "bridgeMm": 22.5,
      "templeMm": 145,
      "lensHeightMm": 32.4196,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.2,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 10.3
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#242627",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#34483b",
      "lensOpacity": 0.72,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.11,
        0.16,
        0.12
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-lombok-luxe-black-sun-1-front.jpg", import.meta.url).href
  },
  {
    "id": "raja-reef-olive-gove",
    "model": "Raja Reef",
    "colorway": "Olive",
    "line": "Classic",
    "productHandle": "raja-reef-olive-gove",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 46.9364,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.4,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "connectorUsesFrontAcetate": true,
      "profileHeightMm": 7.6
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#527a4d",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.83,
      "acetatePhotoOpacity": 0.88,
      "rivetLengthMm": 0,
      "lensColor": "#ba8b71",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.2268,
        0.1458,
        0.1037
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.3078,
        0.3078,
        0.3014
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-raja-reef-olive-gove-front.jpg", import.meta.url).href
  },
  {
    "id": "raja-reef-sunlight-aura",
    "model": "Raja Reef",
    "colorway": "Sunlight Aura",
    "line": "Classic",
    "productHandle": "raja-reef-sunlight-aura",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 47.0043,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.4,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "connectorUsesFrontAcetate": true,
      "profileHeightMm": 7.6
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateCrystal": true,
      "acetateColor": "#dce2e2",
      "acetateRoughness": 0.08,
      "acetateOpacity": 0.12,
      "acetatePhotoOpacity": 0.18,
      "templeAcetateColor": "#5b341d",
      "templeAcetateOpacity": 0.94,
      "templeAcetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b88847",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.2312,
        0.1484,
        0.0656
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-raja-reef-sunlight-aura-front.jpg", import.meta.url).href
  },
  {
    "id": "raja-reef-morning-lagoon",
    "model": "Raja Reef",
    "colorway": "Morning Lagoon",
    "line": "Classic",
    "productHandle": "raja-reef-morning-lagoon",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 47.5617,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.4,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "connectorUsesFrontAcetate": true,
      "profileHeightMm": 7.6
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#572c26",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#83b7a7",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.1317,
        0.1688,
        0.1564
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-raja-reef-morning-lagoon-front.jpg", import.meta.url).href
  },
  {
    "id": "sumba-hills-black-sun",
    "model": "Sumba Hills",
    "colorway": "Black Sun",
    "line": "Classic",
    "productHandle": "sumba-hills-black-sun",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 39.3884,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.3
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#28221a",
      "acetateRoughness": 0.21,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#7fb2ca",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.1186,
        0.1691,
        0.1918
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sumba-hills-black-sun-front.jpg", import.meta.url).href
  },
  {
    "id": "sumba-hills-olive-gove",
    "model": "Sumba Hills",
    "colorway": "Olive Grove",
    "line": "Classic",
    "productHandle": "sumba-hills-olive-gove",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 39.367,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "profileHeightMm": 6.3
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#354f3b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.75,
      "acetatePhotoOpacity": 0.88,
      "rivetLengthMm": 0,
      "lensColor": "#616f73",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.1391,
        0.1652,
        0.1696
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sumba-hills-olive-gove-front.jpg", import.meta.url).href
  },
  {
    "id": "sumba-hills-sunlight-aura",
    "model": "Sumba Hills",
    "colorway": "Sunlight Aura",
    "line": "Classic",
    "productHandle": "sumba-hills-sunlight-aura",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 23.5,
      "templeMm": 145,
      "lensHeightMm": 39.577,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured",
      "solidConnector": true,
      "connectorUsesFrontAcetate": true,
      "profileHeightMm": 6.3
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateCrystal": true,
      "acetateColor": "#dce2e2",
      "acetateRoughness": 0.08,
      "acetateOpacity": 0.12,
      "acetatePhotoOpacity": 0.18,
      "templeAcetateColor": "#4b2919",
      "templeAcetateOpacity": 0.96,
      "templeAcetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#875225",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.2437,
        0.1442,
        0.0696
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sumba-hills-sunlight-aura-front.jpg", import.meta.url).href
  },
  {
    "id": "komodo-rise-velvet-noir",
    "model": "Komodo Rise",
    "colorway": "Velvet Noir",
    "line": "Classic",
    "productHandle": "komodo-rise-velvet-noir",
    "customizable": false,
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 50.5,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 32.9099,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "solidConnector": true,
      "profileHeightMm": 6.5,
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#17191d",
      "acetateRoughness": 0.22,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#7396ae",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.1131,
        0.1697,
        0.2024
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-komodo-rise-velvet-noir-front.jpg", import.meta.url).href
  },
  {
    "id": "komodo-rise-caramel-swirl",
    "model": "Komodo Rise",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "komodo-rise-caramel-swirl",
    "customizable": false,
    "dims": {
      "widthMm": 150,
      "lensWidthMm": 50.5,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 33.4749,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "solidConnector": true,
      "profileHeightMm": 6.5,
      "widthMm": 3.6,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.65,
      "hingeInsetMm": 1.5,
      "outerInsetMm": 0.15,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 8,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#5a321c",
      "acetateRoughness": 0.22,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 0.97,
      "rivetLengthMm": 0,
      "butterflyRivets": [
        [
          -66.14,
          7.41
        ],
        [
          66.37,
          7.06
        ]
      ],
      "lensColor": "#875127",
      "lensOpacity": 0.62,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.2398,
        0.1449,
        0.0749
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-komodo-rise-caramel-swirl-front.jpg", import.meta.url).href
  },
  {
    "id": "vieux-carre",
    "model": "Vieux carré",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "vieux-carre",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51.4,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 44.1114,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 1,
      "topAtHingeMm": 6,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#5c2f13",
      "acetateRoughness": 0.23,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#785238",
      "lensOpacity": 0.5,
      "lensMirror": 0.05,
      "lensTransmission": [
        0.43,
        0.29,
        0.2
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-vieux-carre-front.jpg", import.meta.url).href
  },
  {
    "id": "silfira",
    "model": "Silfira",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "silfira",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 21.5,
      "templeMm": 145,
      "lensHeightMm": 36.3365,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 4.2
    },
    "temple": {
      "widthMm": 3.8,
      "tipWidthRatio": 0.72,
      "topInsetMm": 0.6,
      "topAtHingeMm": 11.4,
      "hingeInsetMm": 2.5,
      "outerInsetMm": 0.3,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#65320f",
      "acetateRoughness": 0.23,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 0.96,
      "rivetLengthMm": 0,
      "lensColor": "#796556",
      "lensOpacity": 0.42,
      "lensMirror": 0.05,
      "lensTransmission": [
        0.57,
        0.49,
        0.39
      ],
      "lensGradient": 0.85
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-silfira-front.jpg", import.meta.url).href
  },
  {
    "id": "airmax",
    "model": "Airmax",
    "colorway": "Bleu",
    "line": "Handmade",
    "productHandle": "airmax",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 33.6607,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4.2,
      "tipWidthRatio": 0.74,
      "topInsetMm": 0.6,
      "topAtHingeMm": 9.5,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#0d3b6f",
      "acetateRoughness": 0.21,
      "acetateOpacity": 0.86,
      "acetatePhotoOpacity": 0.86,
      "rivetLengthMm": 0,
      "lensColor": "#504991",
      "lensOpacity": 0.55,
      "lensMirror": 0.09,
      "lensTransmission": [
        0.37,
        0.34,
        0.63
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-airmax-front.jpg", import.meta.url).href
  },
  {
    "id": "amber-tide",
    "model": "Amber tide",
    "colorway": "Vert citron",
    "line": "Handmade",
    "productHandle": "amber-tide",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 31.0925,
      "frontDepthMm": 4.8,
      "endPieceDepthMm": 4.5
    },
    "temple": {
      "widthMm": 4.4,
      "tipWidthRatio": 0.75,
      "topInsetMm": 0.5,
      "topAtHingeMm": 7.5,
      "hingeInsetMm": 2.8,
      "outerInsetMm": 0.35,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#a7c66c",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.78,
      "acetatePhotoOpacity": 0.78,
      "rivetLengthMm": 0,
      "lensColor": "#656967",
      "lensOpacity": 0.38,
      "lensMirror": 0.06,
      "lensTransmission": [
        0.67,
        0.66,
        0.68
      ],
      "lensGradient": 0.8
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-amber-tide-front.jpg", import.meta.url).href
  },
  {
    "id": "coca-colada",
    "model": "Coca colada",
    "colorway": "Crystal brown",
    "line": "Handmade",
    "productHandle": "coca-colada",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 15,
      "templeMm": 145,
      "lensHeightMm": 43.6167,
      "frontDepthMm": 5.2,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 5.2,
      "tipWidthRatio": 0.69,
      "topInsetMm": 0.5,
      "topAtHingeMm": 14,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#542d1c",
      "acetateRoughness": 0.22,
      "acetateOpacity": 0.9,
      "acetatePhotoOpacity": 0.92,
      "rivetLengthMm": 0,
      "lensColor": "#885e48",
      "lensOpacity": 0.48,
      "lensMirror": 0.06,
      "lensTransmission": [
        0.6,
        0.42,
        0.32
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-coca-colada-front.jpg", import.meta.url).href
  },
  {
    "id": "tequila-sunrise-2",
    "model": "Tequila sunrise",
    "colorway": "Wood Brown",
    "line": "Handmade",
    "productHandle": "tequila-sunrise-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46.7,
      "bridgeMm": 24.2,
      "templeMm": 145,
      "lensHeightMm": 27.0783,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 5.4,
      "tipWidthRatio": 0.63,
      "topInsetMm": 0.5,
      "topAtHingeMm": 6,
      "hingeInsetMm": 3.5,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6f351d",
      "acetateRoughness": 0.22,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#82bce8",
      "lensOpacity": 0.48,
      "lensMirror": 0.06,
      "lensTransmission": [
        0.18,
        0.58,
        1
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-tequila-sunrise-2-front.jpg", import.meta.url).href
  },
  {
    "id": "muse-2",
    "model": "Muse",
    "colorway": "Crystal Orange",
    "line": "Handmade",
    "productHandle": "muse-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52.1,
      "bridgeMm": 18.9,
      "templeMm": 145,
      "lensHeightMm": 30.8635,
      "frontDepthMm": 5.1,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 5,
      "tipWidthRatio": 0.68,
      "topInsetMm": 0.8,
      "topAtHingeMm": 13.5,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#f0790b",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.83,
      "acetatePhotoOpacity": 0.94,
      "rivetLengthMm": 0,
      "lensColor": "#c38987",
      "lensOpacity": 0.42,
      "lensMirror": 0.04,
      "lensTransmission": [
        0.77,
        0.62,
        0.63
      ],
      "lensGradient": 0.75
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-muse-2-front.jpg", import.meta.url).href
  },
  {
    "id": "muse",
    "model": "Muse",
    "colorway": "Black Sun",
    "line": "Handmade",
    "productHandle": "muse",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52.1,
      "bridgeMm": 18.9,
      "templeMm": 145,
      "lensHeightMm": 30.1987,
      "frontDepthMm": 5.1,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 5.2,
      "tipWidthRatio": 0.68,
      "topInsetMm": 0.8,
      "topAtHingeMm": 16,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#27201b",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#55535d",
      "lensOpacity": 0.54,
      "lensMirror": 0.04,
      "lensTransmission": [
        0.39,
        0.38,
        0.42
      ],
      "lensGradient": 0.18
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-muse-front.jpg", import.meta.url).href
  },
  {
    "id": "muse-1",
    "model": "Muse",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "muse-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52.1,
      "bridgeMm": 18.9,
      "templeMm": 145,
      "lensHeightMm": 30.0159,
      "frontDepthMm": 5.1,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 5.2,
      "tipWidthRatio": 0.68,
      "topInsetMm": 0.8,
      "topAtHingeMm": 16,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#4a281e",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#9d7862",
      "lensOpacity": 0.43,
      "lensMirror": 0.04,
      "lensTransmission": [
        0.71,
        0.56,
        0.47
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-muse-1-front.jpg", import.meta.url).href
  },
  {
    "id": "nostalgia",
    "model": "Nostalgia",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "nostalgia",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51.2,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 43.4539,
      "frontDepthMm": 5.3,
      "endPieceDepthMm": 5.8
    },
    "temple": {
      "widthMm": 4.8,
      "tipWidthRatio": 0.72,
      "topInsetMm": 0.7,
      "topAtHingeMm": 6.7,
      "hingeInsetMm": 3.1,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#4b2819",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#c89878",
      "lensOpacity": 0.38,
      "lensMirror": 0.03,
      "lensTransmission": [
        0.81,
        0.68,
        0.57
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-nostalgia-front.jpg", import.meta.url).href
  },
  {
    "id": "solace",
    "model": "Solace",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "solace",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47.2,
      "bridgeMm": 24.9,
      "templeMm": 145,
      "lensHeightMm": 31.245,
      "frontDepthMm": 3.4,
      "endPieceDepthMm": 5.8
    },
    "temple": {
      "widthMm": 5.1,
      "tipWidthRatio": 0.67,
      "topInsetMm": 0.8,
      "topAtHingeMm": 13.2,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#462514",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 0.98,
      "innerRimWallColor": "#f1eee4",
      "rivetLengthMm": 0,
      "lensColor": "#b9896e",
      "lensOpacity": 0.4,
      "lensMirror": 0.03,
      "lensTransmission": [
        0.78,
        0.64,
        0.52
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-solace-front.jpg", import.meta.url).href
  },
  {
    "id": "sgroppino",
    "model": "Sgroppino",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "sgroppino",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53.4,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 36.2212,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 6.2
    },
    "temple": {
      "widthMm": 5.2,
      "tipWidthRatio": 0.68,
      "topInsetMm": 0.8,
      "topAtHingeMm": 14.2,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#492718",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 0.98,
      "innerRimWallColor": "#f1eee4",
      "rivetLengthMm": 0,
      "lensColor": "#bd896d",
      "lensOpacity": 0.4,
      "lensMirror": 0.03,
      "lensTransmission": [
        0.78,
        0.64,
        0.52
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sgroppino-front.jpg", import.meta.url).href
  },
  {
    "id": "stone",
    "model": "Stone",
    "colorway": "Granit",
    "line": "Handmade",
    "productHandle": "stone",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 54,
      "bridgeMm": 17.5,
      "templeMm": 145,
      "lensHeightMm": 31.5568,
      "frontDepthMm": 6.6,
      "endPieceDepthMm": 6.3
    },
    "temple": {
      "widthMm": 5.4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 18.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#272b2e",
      "acetateRoughness": 0.34,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#687695",
      "lensOpacity": 0.56,
      "lensMirror": 0.1,
      "lensTransmission": [
        0.25,
        0.43,
        0.92
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-stone-front.jpg", import.meta.url).href
  },
  {
    "id": "nebula",
    "model": "Nebula",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "nebula",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 43.6038,
      "frontDepthMm": 5.8,
      "endPieceDepthMm": 6.2
    },
    "temple": {
      "widthMm": 5.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 18,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#462311",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 0.98,
      "innerRimWallColor": "#f1eee4",
      "rivetLengthMm": 0,
      "lensColor": "#bd937b",
      "lensOpacity": 0.4,
      "lensMirror": 0.03,
      "lensTransmission": [
        0.8,
        0.67,
        0.56
      ],
      "lensTransmissionTop": [
        0.58,
        0.4,
        0.31
      ],
      "lensTransmissionBottom": [
        0.89,
        0.84,
        0.72
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-nebula-front.jpg", import.meta.url).href
  },
  {
    "id": "eye-candy",
    "model": "Eye Candy",
    "colorway": "White",
    "line": "Handmade",
    "productHandle": "eye-candy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 33.8526,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 5.4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 9.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#edf0e9",
      "acetateRoughness": 0.28,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "innerRimWallColor": "#edf0e9",
      "rivetLengthMm": 0,
      "lensColor": "#134b9b",
      "lensOpacity": 0.8,
      "lensMirror": 0.07,
      "lensTransmission": [
        0.11,
        0.32,
        0.77
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-eye-candy-front.jpg", import.meta.url).href
  },
  {
    "id": "midnight-mimosa-2",
    "model": "Midnight Mimosa",
    "colorway": "Crystal Grey",
    "line": "Handmade",
    "productHandle": "midnight-mimosa-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 42.1229,
      "frontDepthMm": 5.8,
      "endPieceDepthMm": 5.8
    },
    "temple": {
      "widthMm": 4.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 2.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#55535e",
      "acetateRoughness": 0.23,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 0.98,
      "innerRimWallColor": "#67636d",
      "rivetLengthMm": 0,
      "lensColor": "#ad7fa5",
      "lensOpacity": 0.43,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.73,
        0.55,
        0.7
      ],
      "lensTransmissionTop": [
        0.55,
        0.28,
        0.53
      ],
      "lensTransmissionBottom": [
        0.96,
        0.92,
        0.97
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-midnight-mimosa-2-front.jpg", import.meta.url).href
  },
  {
    "id": "citrus-twist-2",
    "model": "Citrus Twist",
    "colorway": "Crystal Yellow",
    "line": "Handmade",
    "productHandle": "citrus-twist-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 34.0223,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.8
    },
    "temple": {
      "widthMm": 4.4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 7.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e9b931",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.76,
      "acetatePhotoOpacity": 0.82,
      "rivetLengthMm": 0,
      "lensColor": "#b58d62",
      "lensOpacity": 0.38,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.8,
        0.7,
        0.55
      ],
      "lensTransmissionTop": [
        0.66,
        0.45,
        0.31
      ],
      "lensTransmissionBottom": [
        0.95,
        0.95,
        0.84
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-citrus-twist-2-front.jpg", import.meta.url).href
  },
  {
    "id": "stereo",
    "model": "Stereo",
    "colorway": "Jaguar",
    "line": "Handmade",
    "productHandle": "stereo",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 35.7597,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 14.7,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#302115",
      "acetateRoughness": 0.21,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#dfce45",
      "lensOpacity": 0.32,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.89,
        0.82,
        0.46
      ],
      "lensTransmissionTop": [
        0.92,
        0.8,
        0.22
      ],
      "lensTransmissionBottom": [
        0.94,
        0.95,
        0.87
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-stereo-front.jpg", import.meta.url).href
  },
  {
    "id": "slate-sour",
    "model": "Slate Sour",
    "colorway": "Light Tortoise",
    "line": "Handmade",
    "productHandle": "slate-sour",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 28.4698,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 3.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#a79a7e",
      "acetateRoughness": 0.22,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#646473",
      "lensOpacity": 0.4,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.65,
        0.65,
        0.72
      ],
      "lensTransmissionTop": [
        0.36,
        0.37,
        0.46
      ],
      "lensTransmissionBottom": [
        0.93,
        0.91,
        0.84
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-slate-sour-front.jpg", import.meta.url).href
  },
  {
    "id": "saoirse",
    "model": "Saoirse",
    "colorway": "White Marble",
    "line": "Handmade",
    "productHandle": "saoirse",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 31.5418,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 3.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#a8a393",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#61586e",
      "lensOpacity": 0.55,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.36,
        0.31,
        0.43
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-saoirse-front.jpg", import.meta.url).href
  },
  {
    "id": "dawn",
    "model": "Dawn",
    "colorway": "Marble Fantasy",
    "line": "Handmade",
    "productHandle": "dawn",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 39.3142,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 6.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#94817e",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.86,
      "acetatePhotoOpacity": 0.92,
      "rivetLengthMm": 0,
      "lensColor": "#a1817a",
      "lensOpacity": 0.38,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.77,
        0.65,
        0.64
      ],
      "lensTransmissionTop": [
        0.59,
        0.41,
        0.38
      ],
      "lensTransmissionBottom": [
        0.95,
        0.9,
        0.92
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-dawn-front.jpg", import.meta.url).href
  },
  {
    "id": "the-abyss-2",
    "model": "The Abyss",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "the-abyss-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 39,
      "templeMm": 145,
      "lensHeightMm": 34.8646,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#48281b",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#855a3d",
      "lensOpacity": 0.58,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.45,
        0.26,
        0.15
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-the-abyss-2-front.jpg", import.meta.url).href
  },
  {
    "id": "citrus-twist-1",
    "model": "Citrus Twist",
    "colorway": "Ruby",
    "line": "Handmade",
    "productHandle": "citrus-twist-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 32.2094,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#251916",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#a9294c",
      "lensOpacity": 0.52,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.62,
        0.08,
        0.18
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-citrus-twist-1-front.jpg", import.meta.url).href
  },
  {
    "id": "solivina",
    "model": "Solivina",
    "colorway": "Multicolour Tortoise",
    "line": "Handmade",
    "productHandle": "solivina",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 54,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 31.7476,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 4.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#48231d",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#83b6c4",
      "lensOpacity": 0.3,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.59,
        0.79,
        0.85
      ],
      "lensTransmissionTop": [
        0.43,
        0.64,
        0.66
      ],
      "lensTransmissionBottom": [
        0.83,
        0.95,
        0.99
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-solivina-front.jpg", import.meta.url).href
  },
  {
    "id": "luxe-silver-mist",
    "model": "Luxe Co.",
    "colorway": "Silver Mist",
    "line": "Classic",
    "productHandle": "luxe-silver-mist",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 41.1013,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#a4a2ad",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.72,
      "acetatePhotoOpacity": 0.8,
      "rivetLengthMm": 0,
      "lensColor": "#62626b",
      "lensOpacity": 0.55,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.34,
        0.34,
        0.39
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-luxe-silver-mist-front.jpg", import.meta.url).href
  },
  {
    "id": "luxe-caramel-swirl",
    "model": "Luxe Co.",
    "colorway": "Caramel Swirl",
    "line": "Classic",
    "productHandle": "luxe-caramel-swirl",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 40.8941,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#57321a",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#82502a",
      "lensOpacity": 0.58,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.44,
        0.23,
        0.1
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-luxe-caramel-swirl-front.jpg", import.meta.url).href
  },
  {
    "id": "luxe-velvet-noir",
    "model": "Luxe Co.",
    "colorway": "Velvet Noir",
    "line": "Classic",
    "productHandle": "luxe-velvet-noir",
    "customizable": false,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 40.5088,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#25282e",
      "acetateRoughness": 0.48,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#82a6bd",
      "lensOpacity": 0.28,
      "lensMirror": 0.025,
      "lensTransmission": [
        0.48,
        0.66,
        0.77
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-luxe-velvet-noir-front.jpg", import.meta.url).href
  },
  {
    "id": "soulstice",
    "model": "Soulstice",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "soulstice",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 35.1385,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 3.55,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6d381c",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ad8274",
      "lensOpacity": 0.27,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.65,
        0.48,
        0.42
      ],
      "lensGradient": 0.82
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-soulstice-front.jpg", import.meta.url).href
  },
  {
    "id": "glint",
    "model": "Glint",
    "colorway": "Black",
    "line": "Handmade",
    "productHandle": "glint",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 30.5572,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 3.9,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#101517",
      "acetateRoughness": 0.17,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#515b74",
      "lensOpacity": 0.45,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.3,
        0.34,
        0.43
      ],
      "lensGradient": 0.5
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-glint-front.jpg", import.meta.url).href
  },
  {
    "id": "lilt",
    "model": "Lilt",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "lilt",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 32.4342,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.15,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6d381c",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d68b9e",
      "lensOpacity": 0.22,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.84,
        0.52,
        0.6
      ],
      "lensGradient": 0.85
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-lilt-front.jpg", import.meta.url).href
  },
  {
    "id": "cove-1",
    "model": "Cove",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "cove-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 32.013,
      "frontDepthMm": 3.4,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6d381c",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#776266",
      "lensOpacity": 0.3,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.49,
        0.39,
        0.4
      ],
      "lensGradient": 0.74,
      "innerRimWallColor": "#eeeae2"
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cove-1-front.jpg", import.meta.url).href
  },
  {
    "id": "citrus-twist",
    "model": "Citrus Twist",
    "colorway": "Crystal Red",
    "line": "Handmade",
    "productHandle": "citrus-twist",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 32.8686,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#b80826",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 0.91,
      "rivetLengthMm": 0,
      "lensColor": "#88708d",
      "lensOpacity": 0.29,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.57,
        0.44,
        0.6
      ],
      "lensGradient": 0.8
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-citrus-twist-front.jpg", import.meta.url).href
  },
  {
    "id": "bulltini",
    "model": "Bulltini",
    "colorway": "Crystal Grey",
    "line": "Handmade",
    "productHandle": "bulltini",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 31.2287,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 3.65,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#77717f",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 0.94,
      "rivetLengthMm": 0,
      "lensColor": "#91809d",
      "lensOpacity": 0.26,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.61,
        0.49,
        0.65
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bulltini-front.jpg", import.meta.url).href
  },
  {
    "id": "frosted",
    "model": "Frosted",
    "colorway": "Crystal Brown",
    "line": "Handmade",
    "productHandle": "frosted",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 54,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 39.0385,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#715343",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.9,
      "acetatePhotoOpacity": 0.96,
      "rivetLengthMm": 0,
      "lensColor": "#c96676",
      "lensOpacity": 0.25,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.86,
        0.42,
        0.47
      ],
      "lensGradient": 0.9,
      "innerRimWallColor": "#92510b"
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-frosted-front.jpg", import.meta.url).href
  },
  {
    "id": "pisco-sour-1",
    "model": "Pisco Sour",
    "colorway": "Light Tortoise",
    "line": "Handmade",
    "productHandle": "pisco-sour-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 24.1141,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#92795c",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ec9fbc",
      "lensOpacity": 0.19,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.96,
        0.65,
        0.78
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-pisco-sour-1-front.jpg", import.meta.url).href
  },
  {
    "id": "bourbon-buzz-1",
    "model": "Bourbon Buzz",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "bourbon-buzz-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 29,
      "templeMm": 145,
      "lensHeightMm": 39.2148,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#693417",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#a16f42",
      "lensOpacity": 0.38,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.59,
        0.36,
        0.19
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bourbon-buzz-1-front.jpg", import.meta.url).href
  },
  {
    "id": "the-abyss-1",
    "model": "The Abyss",
    "colorway": "Crystal Grey",
    "line": "Handmade",
    "productHandle": "the-abyss-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 38,
      "templeMm": 145,
      "lensHeightMm": 35.4509,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#77717e",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.84,
      "acetatePhotoOpacity": 0.94,
      "rivetLengthMm": 0,
      "lensColor": "#756879",
      "lensOpacity": 0.36,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.45,
        0.38,
        0.47
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-the-abyss-1-front.jpg", import.meta.url).href
  },
  {
    "id": "the-abyss",
    "model": "The Abyss",
    "colorway": "Dark Tortoise",
    "line": "Handmade",
    "productHandle": "the-abyss",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 38,
      "templeMm": 145,
      "lensHeightMm": 35.3447,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#332017",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#494555",
      "lensOpacity": 0.54,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.26,
        0.24,
        0.32
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-the-abyss-front.jpg", import.meta.url).href
  },
  {
    "id": "tequila-temptation-1",
    "model": "Tequila Temptation",
    "colorway": "Black Textured",
    "line": "Handmade",
    "productHandle": "tequila-temptation-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 33.9938,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 14.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#232326",
      "acetateRoughness": 0.3,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b9c297",
      "lensOpacity": 0.19,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.77,
        0.81,
        0.61
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-tequila-temptation-1-front.jpg", import.meta.url).href
  },
  {
    "id": "manhattan-magic-1",
    "model": "Manhattan Magic",
    "colorway": "White",
    "line": "Handmade",
    "productHandle": "manhattan-magic-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 40.533,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 3.5,
      "hingeOffsetYMm": [
        1.5,
        0
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e8e0d8",
      "acetateRoughness": 0.2,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "frontPhotoUniformBelowMm": [
        0,
        -10
      ],
      "rivetLengthMm": 0,
      "lensColor": "#925749",
      "lensOpacity": 0.32,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.68,
        0.39,
        0.3
      ],
      "lensGradient": 0.95
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-manhattan-magic-1-front.jpg", import.meta.url).href
  },
  {
    "id": "margarita-mojo-copy",
    "model": "Margarita Mojo",
    "colorway": "Crystal Brown",
    "line": "Handmade",
    "productHandle": "margarita-mojo-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 45.542,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#b77b55",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.78,
      "acetatePhotoOpacity": 0.91,
      "rivetLengthMm": 0,
      "lensColor": "#df9273",
      "lensOpacity": 0.24,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.9,
        0.61,
        0.46
      ],
      "lensGradient": 0.95
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-margarita-mojo-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "cherry-blossom-breeze-1",
    "model": "Cherry Blossom Breeze",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "cherry-blossom-breeze-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 27.7505,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 6.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#783a21",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.91,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#b9776c",
      "lensOpacity": 0.25,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.76,
        0.47,
        0.42
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cherry-blossom-breeze-1-front.jpg", import.meta.url).href
  },
  {
    "id": "milky-punch-3",
    "model": "Milky Punch",
    "colorway": "Marble Black & Cream",
    "line": "Handmade",
    "productHandle": "milky-punch-3",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 35.566,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 13,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#c2aa83",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#a676a1",
      "lensOpacity": 0.29,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.7,
        0.43,
        0.68
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-milky-punch-3-front.jpg", import.meta.url).href
  },
  {
    "id": "milky-punch-2",
    "model": "Milky Punch",
    "colorway": "Crystal Nude",
    "line": "Handmade",
    "productHandle": "milky-punch-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 36.3586,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 13.4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#c78955",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.78,
      "acetatePhotoOpacity": 0.92,
      "rivetLengthMm": 0,
      "lensColor": "#c48e89",
      "lensOpacity": 0.22,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.84,
        0.58,
        0.54
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-milky-punch-2-front.jpg", import.meta.url).href
  },
  {
    "id": "milky-punch-copy",
    "model": "Milky Punch",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "milky-punch-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 36.6833,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 13.9,
      "hingeOffsetYMm": [
        0,
        -2.3
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6e3319",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.91,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#bd8d89",
      "lensOpacity": 0.23,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.81,
        0.57,
        0.54
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-milky-punch-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "milky-punch-1",
    "model": "Milky Punch",
    "colorway": "Blue Tortoise",
    "line": "Handmade",
    "productHandle": "milky-punch-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 36.83,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 14,
      "hingeOffsetYMm": [
        0,
        -1.5
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -3,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#713528",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.91,
      "acetatePhotoOpacity": 0.98,
      "rivetLengthMm": 0,
      "lensColor": "#8c77c7",
      "lensOpacity": 0.3,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.53,
        0.4,
        0.78
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-milky-punch-1-front.jpg", import.meta.url).href
  },
  {
    "id": "vino-vision-1",
    "model": "Vino Vision",
    "colorway": "Yellow Tortoise",
    "line": "Handmade",
    "productHandle": "vino-vision-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 43.6024,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 11.5,
      "hingeOffsetYMm": [
        0,
        1
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -2,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6e4919",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.89,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#68616a",
      "lensOpacity": 0.4,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.49,
        0.45,
        0.48
      ],
      "lensGradient": 0.1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-vino-vision-1-front.jpg", import.meta.url).href
  },
  {
    "id": "daiquiri-dream-1",
    "model": "Daiquiri Dream",
    "colorway": "Graphite & White",
    "line": "Handmade",
    "productHandle": "daiquiri-dream-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 31.0516,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.8,
      "hingeOffsetYMm": [
        0,
        0.5
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#505157",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#657080",
      "lensOpacity": 0.3,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.51,
        0.55,
        0.64
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-daiquiri-dream-1-front.jpg", import.meta.url).href
  },
  {
    "id": "daiquiri-dream-copy",
    "model": "Daiquiri Dream",
    "colorway": "Crystal Red & White",
    "line": "Handmade",
    "productHandle": "daiquiri-dream-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 30.8333,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.6,
      "hingeOffsetYMm": [
        0,
        0.5
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#d84217",
      "acetateRoughness": 0.16,
      "acetateOpacity": 0.8,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#cb7d7d",
      "lensOpacity": 0.26,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.83,
        0.48,
        0.49
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-daiquiri-dream-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "moonbeam-s-elexir-3",
    "model": "Moonbeam’s Elixir",
    "colorway": "Crystal Green & White",
    "line": "Handmade",
    "productHandle": "moonbeam-s-elexir-3",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 32.4544,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 13.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#68ae82",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.91,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#619286",
      "lensOpacity": 0.25,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.52,
        0.73,
        0.67
      ],
      "lensGradient": 0.92
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moonbeam-s-elexir-3-front.jpg", import.meta.url).href
  },
  {
    "id": "mysterious-martini-1",
    "model": "Mysterious Martini",
    "colorway": "Crystal Orange",
    "line": "Handmade",
    "productHandle": "mysterious-martini-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 26.9767,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#ed8115",
      "acetateRoughness": 0.16,
      "acetateOpacity": 0.83,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ad7d56",
      "lensOpacity": 0.26,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.72,
        0.51,
        0.34
      ],
      "lensGradient": 0.18
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mysterious-martini-1-front.jpg", import.meta.url).href
  },
  {
    "id": "mudslide-1",
    "model": "Mudslide",
    "colorway": "Crystal Brown",
    "line": "Handmade",
    "productHandle": "mudslide-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 48,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 39.9296,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.6,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 11.1,
      "hingeOffsetYMm": [
        1,
        0
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": 0,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#a44d0d",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.86,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c58f83",
      "lensOpacity": 0.19,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.84,
        0.64,
        0.61
      ],
      "lensGradient": 0.97
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mudslide-1-front.jpg", import.meta.url).href
  },
  {
    "id": "bourbon-bold-2",
    "model": "Bourbon Bold",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "bourbon-bold-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 44,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 39.3637,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 16.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#422519",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ed6d65",
      "lensOpacity": 0.23,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.95,
        0.47,
        0.42
      ],
      "lensGradient": 0.96
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bourbon-bold-2-front.jpg", import.meta.url).href
  },
  {
    "id": "bourbon-bold-1",
    "model": "Bourbon Bold",
    "colorway": "Crystal Blue",
    "line": "Handmade",
    "productHandle": "bourbon-bold-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 44,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 38.2036,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 19,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#25afd2",
      "acetateRoughness": 0.16,
      "acetateOpacity": 0.78,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#73597f",
      "lensOpacity": 0.22,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.57,
        0.44,
        0.65
      ],
      "lensGradient": 0.98
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bourbon-bold-1-front.jpg", import.meta.url).href
  },
  {
    "id": "tequila-sunrise-1",
    "model": "Tequila Sunrise",
    "colorway": "Crystal Purple & Blue",
    "line": "Handmade",
    "productHandle": "tequila-sunrise-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 44,
      "bridgeMm": 24,
      "templeMm": 145,
      "lensHeightMm": 25.8665,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.1,
      "hingeOffsetYMm": [
        0.7,
        0
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": 0,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#9039b6",
      "acetateRoughness": 0.16,
      "acetateOpacity": 0.79,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ba8baa",
      "lensOpacity": 0.15,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.86,
        0.69,
        0.82
      ],
      "lensGradient": 0.12
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-tequila-sunrise-1-front.jpg", import.meta.url).href
  },
  {
    "id": "tequila-sunrise",
    "model": "Tequila Sunrise",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "tequila-sunrise",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 44,
      "bridgeMm": 24,
      "templeMm": 145,
      "lensHeightMm": 26.5134,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.7,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.2,
      "hingeOffsetYMm": [
        0.5,
        0
      ],
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": 0,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#432219",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#da6f67",
      "lensOpacity": 0.25,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.89,
        0.44,
        0.4
      ],
      "lensGradient": 0.08
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-tequila-sunrise-front.jpg", import.meta.url).href
  },
  {
    "id": "bellini-babe-3",
    "model": "Bellini Babe",
    "colorway": "Ivory White",
    "line": "Handmade",
    "productHandle": "bellini-babe-3",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 31.3289,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 12.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e5dfd3",
      "acetateRoughness": 0.24,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#598faf",
      "lensOpacity": 0.23,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.42,
        0.65,
        0.8
      ],
      "lensGradient": 0.91
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bellini-babe-3-front.jpg", import.meta.url).href
  },
  {
    "id": "bellini-babe-2",
    "model": "Bellini Babe",
    "colorway": "Tortoise & Pearl",
    "line": "Handmade",
    "productHandle": "bellini-babe-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 30.6731,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 12.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#43281c",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ad8780",
      "lensOpacity": 0.2,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.78,
        0.61,
        0.58
      ],
      "lensGradient": 0.89
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bellini-babe-2-front.jpg", import.meta.url).href
  },
  {
    "id": "bellini-babe-1",
    "model": "Bellini Babe",
    "colorway": "Crystal Blue",
    "line": "Handmade",
    "productHandle": "bellini-babe-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 32.2545,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 12.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#25405c",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.8,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#8970bf",
      "lensOpacity": 0.23,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.61,
        0.47,
        0.83
      ],
      "lensGradient": 0.96
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bellini-babe-1-front.jpg", import.meta.url).href
  },
  {
    "id": "moonbeam-s-elexir-2",
    "model": "Moonbeam’s Elixir",
    "colorway": "Ivory White",
    "line": "Handmade",
    "productHandle": "moonbeam-s-elexir-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 33.1113,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 13.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e6ded4",
      "acetateRoughness": 0.24,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b48768",
      "lensOpacity": 0.23,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.79,
        0.6,
        0.45
      ],
      "lensGradient": 0.83
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moonbeam-s-elexir-2-front.jpg", import.meta.url).href
  },
  {
    "id": "moonbeam-s-elexir-1",
    "model": "Moonbeam’s Elixir",
    "colorway": "Black & Marble",
    "line": "Handmade",
    "productHandle": "moonbeam-s-elexir-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 28.7786,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#121014",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#905a85",
      "lensOpacity": 0.29,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.63,
        0.37,
        0.58
      ],
      "lensGradient": 0.24
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moonbeam-s-elexir-1-front.jpg", import.meta.url).href
  },
  {
    "id": "paloma-perfection-2",
    "model": "Paloma Perfection",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "paloma-perfection-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 33.8333,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 11,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#493020",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d29779",
      "lensOpacity": 0.2,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.88,
        0.64,
        0.5
      ],
      "lensGradient": 0.12
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-paloma-perfection-2-front.jpg", import.meta.url).href
  },
  {
    "id": "paloma-perfection-1",
    "model": "Paloma Perfection",
    "colorway": "Crystal Yellow & Pink",
    "line": "Handmade",
    "productHandle": "paloma-perfection-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 36.9692,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 11,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "templeAcetateColor": "#edbdb5",
      "acetateColor": "#edb94b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.8,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#f4d682",
      "lensOpacity": 0.1,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.99,
        0.92,
        0.71
      ],
      "lensGradient": 0.04
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-paloma-perfection-1-front.jpg", import.meta.url).href
  },
  {
    "id": "monaco-moment-1",
    "model": "Monaco Moment",
    "colorway": "Burgundy & Pink",
    "line": "Handmade",
    "productHandle": "monaco-moment-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 43.0722,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 9.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "templeAcetateColor": "#e8c3c3",
      "acetateColor": "#411320",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d47b9e",
      "lensOpacity": 0.24,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.9,
        0.51,
        0.67
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-monaco-moment-1-front.jpg", import.meta.url).href
  },
  {
    "id": "monaco-moment",
    "model": "Monaco Moment",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "monaco-moment",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 42.7869,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 11.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#4d301b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c6a342",
      "lensOpacity": 0.29,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.83,
        0.66,
        0.24
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-monaco-moment-front.jpg", import.meta.url).href
  },
  {
    "id": "moon-river-2",
    "model": "Moon River",
    "colorway": "Brown Tortoise",
    "line": "Handmade",
    "productHandle": "moon-river-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 24.9779,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#3d1c13",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#aa6955",
      "lensOpacity": 0.28,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.75,
        0.44,
        0.34
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moon-river-2-front.jpg", import.meta.url).href
  },
  {
    "id": "moon-river-1",
    "model": "Moon River",
    "colorway": "Crystal Red",
    "line": "Handmade",
    "productHandle": "moon-river-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 24.9779,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 4.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#d50029",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ef7298",
      "lensOpacity": 0.28,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.91,
        0.5,
        0.65
      ],
      "lensGradient": 0.55
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moon-river-1-front.jpg", import.meta.url).href
  },
  {
    "id": "moon-river",
    "model": "Moon River",
    "colorway": "White Tortoise",
    "line": "Handmade",
    "productHandle": "moon-river",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 25.9607,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 3.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#302932",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b8a3d1",
      "lensOpacity": 0.16,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.8,
        0.72,
        0.89
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moon-river-front.jpg", import.meta.url).href
  },
  {
    "id": "dreamer-s-delight",
    "model": "Dreamer’s Delight",
    "colorway": "White",
    "line": "Handmade",
    "productHandle": "dreamer-s-delight",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 39.4483,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8.7,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e4e3dc",
      "acetateRoughness": 0.22,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#514b80",
      "lensOpacity": 0.57,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.3,
        0.27,
        0.49
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-dreamer-s-delight-front.jpg", import.meta.url).href
  },
  {
    "id": "moonbeam-s-elexir",
    "model": "Moonbeam’s Elixir",
    "colorway": "Navy Blue",
    "line": "Handmade",
    "productHandle": "moonbeam-s-elexir",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 31.5153,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8.7,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#15233f",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#44abd7",
      "lensOpacity": 0.3,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.3,
        0.68,
        0.83
      ],
      "lensGradient": 0.8
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-moonbeam-s-elexir-front.jpg", import.meta.url).href
  },
  {
    "id": "whispering-willow",
    "model": "Whispering Willow",
    "colorway": "Burgundy",
    "line": "Handmade",
    "productHandle": "whispering-willow",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 28.911,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 16.2,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#471619",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#cd8199",
      "lensOpacity": 0.3,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.87,
        0.54,
        0.65
      ],
      "lensGradient": 0.8
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-whispering-willow-front.jpg", import.meta.url).href
  },
  {
    "id": "elderflower-enemy",
    "model": "Elderflower Enemy",
    "colorway": "Amber Tortoise",
    "line": "Handmade",
    "productHandle": "elderflower-enemy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 30.5055,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 17.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#b45d18",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d4a1ac",
      "lensOpacity": 0.18,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.92,
        0.73,
        0.78
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-elderflower-enemy-front.jpg", import.meta.url).href
  },
  {
    "id": "sparkling-sip-copy",
    "model": "Cosmopolitan Feelings",
    "colorway": "Crystal Rose",
    "line": "Handmade",
    "productHandle": "sparkling-sip-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 30.1777,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 20,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#edcbd3",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.38,
      "acetatePhotoOpacity": 0.55,
      "rivetLengthMm": 0,
      "lensColor": "#d4a1ac",
      "lensOpacity": 0.18,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.92,
        0.73,
        0.78
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sparkling-sip-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "sparkling-sip",
    "model": "Sparkling Sip",
    "colorway": "Burgundy",
    "line": "Handmade",
    "productHandle": "sparkling-sip",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 40.1081,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 23,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#431c23",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d4a1ac",
      "lensOpacity": 0.18,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.92,
        0.73,
        0.78
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sparkling-sip-front.jpg", import.meta.url).href
  },
  {
    "id": "bellini-brilliance",
    "model": "Bellini Brilliance",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "bellini-brilliance",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 42.1184,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 23.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#683618",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#986c50",
      "lensOpacity": 0.38,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.64,
        0.43,
        0.3
      ],
      "lensGradient": 0.8
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bellini-brilliance-front.jpg", import.meta.url).href
  },
  {
    "id": "bellini-bombshell",
    "model": "Bellini Bombshell",
    "colorway": "Black & Tortoise",
    "line": "Handmade",
    "productHandle": "bellini-bombshell",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 32.6971,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 14,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#181e27",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#859994",
      "lensOpacity": 0.23,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.69,
        0.77,
        0.74
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bellini-bombshell-front.jpg", import.meta.url).href
  },
  {
    "id": "bellini-babe",
    "model": "Bellini Babe",
    "colorway": "Crystal Orange",
    "line": "Handmade",
    "productHandle": "bellini-babe",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 31.9857,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 14,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#ff7207",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.82,
      "acetatePhotoOpacity": 0.9,
      "rivetLengthMm": 0,
      "lensColor": "#b96d41",
      "lensOpacity": 0.29,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.8,
        0.56,
        0.39
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bellini-babe-front.jpg", import.meta.url).href
  },
  {
    "id": "angel-s-kiss",
    "model": "Angel’s Kiss",
    "colorway": "Pearl White",
    "line": "Handmade",
    "productHandle": "angel-s-kiss",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 27.4113,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 17.5,
      "hingeInsetMm": 5.2,
      "outerInsetMm": 2.8,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#ece5dc",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#cd9bb3",
      "lensOpacity": 0.15,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.96,
        0.86,
        0.92
      ],
      "lensGradient": 0.8
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-angel-s-kiss-front.jpg", import.meta.url).href
  },
  {
    "id": "cherry-blossom-breeze",
    "model": "Cherry Blossom Breeze",
    "colorway": "Smoke Brown",
    "line": "Handmade",
    "productHandle": "cherry-blossom-breeze",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 29.9765,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 7.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 3.5,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#65513b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.84,
      "acetatePhotoOpacity": 0.94,
      "rivetLengthMm": 0,
      "lensColor": "#22262c",
      "lensOpacity": 0.7,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.21,
        0.23,
        0.25
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cherry-blossom-breeze-front.jpg", import.meta.url).href
  },
  {
    "id": "midnight-mirage",
    "model": "Midnight Mirage",
    "colorway": "Smoke Brown",
    "line": "Handmade",
    "productHandle": "midnight-mirage",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 28.9926,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 6.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#665541",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.84,
      "acetatePhotoOpacity": 0.94,
      "rivetLengthMm": 0,
      "lensColor": "#77707d",
      "lensOpacity": 0.36,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.57,
        0.54,
        0.62
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-midnight-mirage-front.jpg", import.meta.url).href
  },
  {
    "id": "bushwacker",
    "model": "Bushwacker",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "bushwacker",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 34.3122,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 12.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#40201b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b47842",
      "lensOpacity": 0.32,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.78,
        0.53,
        0.32
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bushwacker-front.jpg", import.meta.url).href
  },
  {
    "id": "pisco-sour",
    "model": "Pisco Sour",
    "colorway": "Tortoise & Orange",
    "line": "Handmade",
    "productHandle": "pisco-sour",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 24.736,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#54301b",
      "acetateRoughness": 0.17,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d67622",
      "lensOpacity": 0.44,
      "lensMirror": 0.015,
      "lensTransmission": [
        0.84,
        0.39,
        0.11
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-pisco-sour-front.jpg", import.meta.url).href
  },
  {
    "id": "paloma-perfection",
    "model": "Paloma Perfection",
    "colorway": "Dark Tortoise",
    "line": "Handmade",
    "productHandle": "paloma-perfection",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 35.411,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#4f2d19",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b47842",
      "lensOpacity": 0.32,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.78,
        0.53,
        0.32
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-paloma-perfection-front.jpg", import.meta.url).href
  },
  {
    "id": "bramble-lover",
    "model": "Bramble Lover",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "bramble-lover",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 43,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 48.0781,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 9.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#40201b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c8977e",
      "lensOpacity": 0.24,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.9,
        0.7,
        0.59
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bramble-lover-front.jpg", import.meta.url).href
  },
  {
    "id": "french-seventy-five",
    "model": "French Seventy Five",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "french-seventy-five",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 53,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 50.9601,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 4.5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 21.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#452715",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#9b9b83",
      "lensOpacity": 0.32,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.67,
        0.69,
        0.56
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-french-seventy-five-front.jpg", import.meta.url).href
  },
  {
    "id": "gibson-groove",
    "model": "Gibson Groove",
    "colorway": "White",
    "line": "Handmade",
    "productHandle": "gibson-groove",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 44.8592,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e6e5da",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ba7049",
      "lensOpacity": 0.36,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.83,
        0.5,
        0.3
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gibson-groove-front.jpg", import.meta.url).href
  },
  {
    "id": "mahogany-mirage",
    "model": "Mahogany Mirage",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "mahogany-mirage",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 41.2932,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 2.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#40201b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#7cbed9",
      "lensOpacity": 0.24,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.57,
        0.82,
        0.92
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mahogany-mirage-front.jpg", import.meta.url).href
  },
  {
    "id": "vino-vision",
    "model": "Vino Vision",
    "colorway": "Yellow Tortoise Violet",
    "line": "Handmade",
    "productHandle": "vino-vision",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 43.7434,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 13,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#6e4919",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.89,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#8d9fe0",
      "lensOpacity": 0.3,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.59,
        0.65,
        0.91
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-vino-vision-front.jpg", import.meta.url).href
  },
  {
    "id": "manhattan-magic",
    "model": "Manhattan Magic",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "manhattan-magic",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 43.2859,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#68341f",
      "acetateRoughness": 0.18,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#bca08a",
      "lensOpacity": 0.26,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.84,
        0.69,
        0.56
      ],
      "lensGradient": 0.9
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-manhattan-magic-front.jpg", import.meta.url).href
  },
  {
    "id": "clover-club",
    "model": "Clover Club",
    "colorway": "Crystal Smoke",
    "line": "Handmade",
    "productHandle": "clover-club",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 54,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 31.1806,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#82969e",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.54,
      "acetatePhotoOpacity": 0.72,
      "rivetLengthMm": 0,
      "lensColor": "#91b0c0",
      "lensOpacity": 0.28,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.67,
        0.78,
        0.85
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-clover-club-front.jpg", import.meta.url).href
  },
  {
    "id": "rum-razzle",
    "model": "Rum Razzle",
    "colorway": "Crystal Smoke",
    "line": "Handmade",
    "productHandle": "rum-razzle",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 37.8396,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 16,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#82969e",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.54,
      "acetatePhotoOpacity": 0.72,
      "rivetLengthMm": 0,
      "lensColor": "#8c8795",
      "lensOpacity": 0.4,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.43,
        0.41,
        0.48
      ],
      "lensTransmissionBottom": [
        0.83,
        0.86,
        0.86
      ],
      "lensGradient": 1
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-rum-razzle-front.jpg", import.meta.url).href
  },
  {
    "id": "jungle-bird",
    "model": "Jungle Bird",
    "colorway": "Tortoise Blue",
    "line": "Handmade",
    "productHandle": "jungle-bird",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 38.7106,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10.7,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#372921",
      "acetateRoughness": 0.21,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#759ab6",
      "lensOpacity": 0.27,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.62,
        0.74,
        0.85
      ],
      "lensGradient": 0.45
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-jungle-bird-front.jpg", import.meta.url).href
  },
  {
    "id": "sake-shades",
    "model": "Sake Shades",
    "colorway": "Dark Tortoise",
    "line": "Handmade",
    "productHandle": "sake-shades",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 23,
      "templeMm": 145,
      "lensHeightMm": 42.1063,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#352019",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c39b61",
      "lensOpacity": 0.4,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.75,
        0.53,
        0.27
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-sake-shades-front.jpg", import.meta.url).href
  },
  {
    "id": "bourbon-buzz",
    "model": "Bourbon Buzz",
    "colorway": "Tortoise Rose",
    "line": "Handmade",
    "productHandle": "bourbon-buzz",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 29,
      "templeMm": 145,
      "lensHeightMm": 38.9758,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8.5,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#513523",
      "acetateRoughness": 0.24,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#cda3aa",
      "lensOpacity": 0.14,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.87,
        0.79,
        0.8
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bourbon-buzz-front.jpg", import.meta.url).href
  },
  {
    "id": "bourbon-sidecar",
    "model": "Bourbon Sidecar",
    "colorway": "Yellow Tortoise",
    "line": "Handmade",
    "productHandle": "bourbon-sidecar",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 43.7178,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#472414",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#7796cf",
      "lensOpacity": 0.34,
      "lensMirror": 0.03,
      "lensTransmission": [
        0.38,
        0.49,
        0.78
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-bourbon-sidecar-front.jpg", import.meta.url).href
  },
  {
    "id": "mudslide",
    "model": "Mudslide",
    "colorway": "Yellow Tortoise",
    "line": "Handmade",
    "productHandle": "mudslide",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 42.1377,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 10,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#67431c",
      "acetateRoughness": 0.22,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#9b7261",
      "lensOpacity": 0.34,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.72,
        0.58,
        0.5
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mudslide-front.jpg", import.meta.url).href
  },
  {
    "id": "tequila-temptation-copy",
    "model": "Red Snapper",
    "colorway": "Crystal",
    "line": "Handmade",
    "productHandle": "tequila-temptation-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 24,
      "templeMm": 145,
      "lensHeightMm": 29.3558,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 12,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#c3cdca",
      "acetateRoughness": 0.15,
      "acetateOpacity": 0.28,
      "acetatePhotoOpacity": 0.48,
      "rivetLengthMm": 0,
      "lensColor": "#91a7a4",
      "lensOpacity": 0.33,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.47,
        0.56,
        0.54
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.83,
        0.88,
        0.84
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-tequila-temptation-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "tequila-temptation",
    "model": "Tequila Temptation",
    "colorway": "Tortoise Blue",
    "line": "Handmade",
    "productHandle": "tequila-temptation",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 51,
      "bridgeMm": 21,
      "templeMm": 145,
      "lensHeightMm": 34.4373,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 11.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#53301b",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#3989dc",
      "lensOpacity": 0.57,
      "lensMirror": 0.035,
      "lensTransmission": [
        0.075,
        0.33,
        0.7
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-tequila-temptation-front.jpg", import.meta.url).href
  },
  {
    "id": "daiquiri-dream",
    "model": "Daiquiri Dream",
    "colorway": "Tortoise Rose",
    "line": "Handmade",
    "productHandle": "daiquiri-dream",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 32.045,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#785021",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#e6adb0",
      "lensOpacity": 0.15,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.94,
        0.77,
        0.76
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-daiquiri-dream-front.jpg", import.meta.url).href
  },
  {
    "id": "margarita-muse",
    "model": "Margarita Muse",
    "colorway": "Tortoise",
    "line": "Handmade",
    "productHandle": "margarita-muse",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 26,
      "templeMm": 145,
      "lensHeightMm": 43.3146,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 9.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#71491f",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#414b63",
      "lensOpacity": 0.5,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.16,
        0.2,
        0.29
      ],
      "lensGradient": 0.85
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-margarita-muse-front.jpg", import.meta.url).href
  },
  {
    "id": "margarita-mojo",
    "model": "Margarita Mojo",
    "colorway": "Tortoise Violet",
    "line": "Handmade",
    "productHandle": "margarita-mojo",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 26,
      "templeMm": 145,
      "lensHeightMm": 44.0775,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#785026",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#847ba8",
      "lensOpacity": 0.33,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.49,
        0.43,
        0.64
      ],
      "lensGradient": 0.72
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-margarita-mojo-front.jpg", import.meta.url).href
  },
  {
    "id": "ocean-s-embrace-copy",
    "model": "Tequila Sunrise",
    "colorway": "Yellow Tortoise Orange",
    "line": "Handmade",
    "productHandle": "ocean-s-embrace-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 27.3361,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#482517",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ff9700",
      "lensOpacity": 0.48,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.97,
        0.41,
        0.015
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-ocean-s-embrace-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "milky-punch",
    "model": "Milky Punch",
    "colorway": "Tortoise Grey Gradient",
    "line": "Handmade",
    "productHandle": "milky-punch",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 24,
      "templeMm": 145,
      "lensHeightMm": 35.2185,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 15,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#57301c",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#777485",
      "lensOpacity": 0.4,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.34,
        0.33,
        0.42
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.9,
        0.9,
        0.9
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-milky-punch-front.jpg", import.meta.url).href
  },
  {
    "id": "rob-roy",
    "model": "Rob Roy",
    "colorway": "Blue Tortoise",
    "line": "Handmade",
    "productHandle": "rob-roy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 52,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 38.0255,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 16,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#402b27",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#69afd1",
      "lensOpacity": 0.36,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.28,
        0.63,
        0.84
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.77,
        0.87,
        0.89
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-rob-roy-front.jpg", import.meta.url).href
  },
  {
    "id": "gilmet-joy-copy",
    "model": "Last Word",
    "colorway": "Crystal Smoke",
    "line": "Handmade",
    "productHandle": "gilmet-joy-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 45,
      "bridgeMm": 30,
      "templeMm": 145,
      "lensHeightMm": 40.3929,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 18.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#81848d",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.58,
      "acetatePhotoOpacity": 0.72,
      "rivetLengthMm": 0,
      "lensColor": "#96949d",
      "lensOpacity": 0.35,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.49,
        0.48,
        0.53
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.91,
        0.92,
        0.92
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gilmet-joy-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "gilmet-joy",
    "model": "Gilmet Joy",
    "colorway": "Yellow Tortoise Olive",
    "line": "Handmade",
    "productHandle": "gilmet-joy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 26,
      "templeMm": 145,
      "lensHeightMm": 42.8915,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 4.5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 15.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#725023",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#959e88",
      "lensOpacity": 0.28,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.56,
        0.61,
        0.48
      ],
      "lensGradient": 0.35,
      "lensTransmissionBottom": [
        0.64,
        0.69,
        0.57
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-gilmet-joy-front.jpg", import.meta.url).href
  },
  {
    "id": "singapore-sling",
    "model": "Singapore Sling",
    "colorway": "Crystal Orange",
    "line": "Handmade",
    "productHandle": "singapore-sling",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 38,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 30.7025,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 9.05,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#dd720d",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.9,
      "acetatePhotoOpacity": 0.9,
      "rivetLengthMm": 0,
      "lensColor": "#d49a82",
      "lensOpacity": 0.16,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.91,
        0.77,
        0.69
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-singapore-sling-front.jpg", import.meta.url).href
  },
  {
    "id": "secret-serendipity",
    "model": "Secret Serendipity",
    "colorway": "Brown Tortoise Blue",
    "line": "Handmade",
    "productHandle": "secret-serendipity",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 27,
      "templeMm": 145,
      "lensHeightMm": 41.788,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 13.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#58301e",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#388bdc",
      "lensOpacity": 0.56,
      "lensMirror": 0.02,
      "lensTransmission": [
        0.08,
        0.34,
        0.71
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-secret-serendipity-front.jpg", import.meta.url).href
  },
  {
    "id": "mirthful-mimosa",
    "model": "Mirthful Mimosa",
    "colorway": "Navy Blue",
    "line": "Handmade",
    "productHandle": "mirthful-mimosa",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 42,
      "bridgeMm": 26,
      "templeMm": 145,
      "lensHeightMm": 41.6688,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 5.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#15263e",
      "acetateRoughness": 0.2,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#7faac9",
      "lensOpacity": 0.26,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.63,
        0.77,
        0.88
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mirthful-mimosa-front.jpg", import.meta.url).href
  },
  {
    "id": "mimosa-marvel",
    "model": "Mimosa Marvel",
    "colorway": "Warm Tortoise Green",
    "line": "Handmade",
    "productHandle": "mimosa-marvel",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 45,
      "bridgeMm": 30,
      "templeMm": 145,
      "lensHeightMm": 45.8206,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 6.8,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#713514",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.94,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#577f70",
      "lensOpacity": 0.48,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.25,
        0.43,
        0.34
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mimosa-marvel-front.jpg", import.meta.url).href
  },
  {
    "id": "magnetic-martini-copy",
    "model": "Midnight Mimosa",
    "colorway": "Dark Tortoise Brown",
    "line": "Handmade",
    "productHandle": "magnetic-martini-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 42,
      "bridgeMm": 35,
      "templeMm": 145,
      "lensHeightMm": 41.2444,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 5.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#44301e",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#996b3e",
      "lensOpacity": 0.45,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.56,
        0.31,
        0.14
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-magnetic-martini-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "mysterious-martini-copy",
    "model": "Magnetic Martini",
    "colorway": "Blue Fleck Tortoise",
    "line": "Handmade",
    "productHandle": "mysterious-martini-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 47,
      "bridgeMm": 22,
      "templeMm": 145,
      "lensHeightMm": 23.9316,
      "frontDepthMm": 6,
      "endPieceDepthMm": 6
    },
    "temple": {
      "widthMm": 4.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 12.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1.2,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#3b2924",
      "acetateRoughness": 0.2,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#5a95cf",
      "lensOpacity": 0.32,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.51,
        0.69,
        0.87
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mysterious-martini-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "mysterious-martini",
    "model": "Mysterious Martini",
    "colorway": "Tortoise Blue",
    "line": "Handmade",
    "productHandle": "mysterious-martini",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 27.612,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.8,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 11.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#4b2918",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.95,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b6cee5",
      "lensOpacity": 0.26,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.57,
        0.72,
        0.85
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-mysterious-martini-front.jpg", import.meta.url).href
  },
  {
    "id": "handmade-1",
    "model": "Martini Majesty",
    "colorway": "Blue Tortoise Lavender",
    "line": "Handmade",
    "productHandle": "handmade-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 45,
      "bridgeMm": 25,
      "templeMm": 145,
      "lensHeightMm": 25.5334,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 5.4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#52332b",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b9bfe3",
      "lensOpacity": 0.17,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.69,
        0.72,
        0.87
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-handmade-1-front.jpg", import.meta.url).href
  },
  {
    "id": "midnight-mimosa-1",
    "model": "Midnight Mimosa",
    "colorway": "Marble Purple Gradient",
    "line": "Handmade",
    "productHandle": "midnight-mimosa-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 41,
      "bridgeMm": 26,
      "templeMm": 145,
      "lensHeightMm": 41.2841,
      "frontDepthMm": 5.8,
      "endPieceDepthMm": 5.8
    },
    "temple": {
      "widthMm": 4.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 5.95,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.6,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#cbb797",
      "acetateRoughness": 0.23,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#ad7fa5",
      "lensOpacity": 0.35,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.62,
        0.38,
        0.58
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.97,
        0.94,
        0.97
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-midnight-mimosa-1-front.jpg", import.meta.url).href
  },
  {
    "id": "midnight-mimosa",
    "model": "Midnight Mimosa",
    "colorway": "Blue Tortoise Mirror",
    "line": "Handmade",
    "productHandle": "midnight-mimosa",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 41,
      "bridgeMm": 36,
      "templeMm": 145,
      "lensHeightMm": 41.3471,
      "frontDepthMm": 4.5,
      "endPieceDepthMm": 4.5
    },
    "temple": {
      "widthMm": 3,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 6.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#4b231e",
      "acetateRoughness": 0.17,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#008ce4",
      "lensOpacity": 0.55,
      "lensMirror": 0.22,
      "lensTransmission": [
        0.03,
        0.36,
        0.7
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-midnight-mimosa-front.jpg", import.meta.url).href
  },
  {
    "id": "airmax-4",
    "model": "Airmax",
    "colorway": "Tortoise Rose",
    "line": "Handmade",
    "productHandle": "airmax-4",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 33.1232,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 6.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#572119",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#d6a9b0",
      "lensOpacity": 0.2,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.86,
        0.66,
        0.69
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-airmax-4-front.jpg", import.meta.url).href
  },
  {
    "id": "airmax-3",
    "model": "Airmax",
    "colorway": "Crystal Mint",
    "line": "Handmade",
    "productHandle": "airmax-3",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 33.0874,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 7.75,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 0.8,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#87c69d",
      "acetateRoughness": 0.16,
      "acetateOpacity": 0.5,
      "acetatePhotoOpacity": 0.68,
      "rivetLengthMm": 0,
      "lensColor": "#529867",
      "lensOpacity": 0.36,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.42,
        0.7,
        0.47
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-airmax-3-front.jpg", import.meta.url).href
  },
  {
    "id": "airmax-2",
    "model": "Airmax",
    "colorway": "White",
    "line": "Handmade",
    "productHandle": "airmax-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 19,
      "templeMm": 145,
      "lensHeightMm": 33.1977,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 4.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#e4e5df",
      "acetateRoughness": 0.2,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#93715f",
      "lensOpacity": 0.42,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.49,
        0.36,
        0.3
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.85,
        0.82,
        0.8
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-airmax-2-front.jpg", import.meta.url).href
  },
  {
    "id": "airmax-1",
    "model": "Airmax",
    "colorway": "White Tortoise",
    "line": "Handmade",
    "productHandle": "airmax-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 50,
      "bridgeMm": 18,
      "templeMm": 145,
      "lensHeightMm": 33.1508,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 5.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#c4bea6",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.97,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#555568",
      "lensOpacity": 0.64,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.2,
        0.2,
        0.27
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-airmax-1-front.jpg", import.meta.url).href
  },
  {
    "id": "cosmopolitan-cruise",
    "model": "Cosmopolitan Cruise",
    "colorway": "Crystal Rose",
    "line": "Handmade",
    "productHandle": "cosmopolitan-cruise",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 46,
      "bridgeMm": 20,
      "templeMm": 145,
      "lensHeightMm": 31.1057,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.5,
      "topAtHingeMm": 13.4,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "templeAcetateColor": "#452a1b",
      "templeAcetateOpacity": 1,
      "templeAcetatePhotoOpacity": 1,
      "acetateColor": "#d7b9c4",
      "acetateRoughness": 0.16,
      "acetateOpacity": 0.5,
      "acetatePhotoOpacity": 0.65,
      "rivetLengthMm": 0,
      "lensColor": "#ca9d99",
      "lensOpacity": 0.12,
      "lensMirror": 0.005,
      "lensTransmission": [
        0.94,
        0.85,
        0.84
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-cosmopolitan-cruise-front.jpg", import.meta.url).href
  },
  {
    "id": "monaco-moment-copy",
    "model": "Monaco Moment",
    "colorway": "Crystal Rose",
    "line": "Handmade",
    "productHandle": "monaco-moment-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 24,
      "templeMm": 145,
      "lensHeightMm": 43.0098,
      "frontDepthMm": 5.5,
      "endPieceDepthMm": 5.5
    },
    "temple": {
      "widthMm": 3.2,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 7.1,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#b57660",
      "acetateRoughness": 0.19,
      "acetateOpacity": 0.68,
      "acetatePhotoOpacity": 0.9,
      "rivetLengthMm": 0,
      "lensColor": "#cda9a0",
      "lensOpacity": 0.26,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.77,
        0.63,
        0.59
      ],
      "lensGradient": 1,
      "lensTransmissionBottom": [
        0.97,
        0.96,
        0.95
      ]
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-monaco-moment-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "rose-radiance",
    "model": "Rosé Radiance",
    "colorway": "Red Tortoise",
    "line": "Handmade",
    "productHandle": "rose-radiance",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 49,
      "bridgeMm": 24,
      "templeMm": 145,
      "lensHeightMm": 44.7513,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 3.5,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.6,
      "topAtHingeMm": 8.6,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#49291f",
      "acetateRoughness": 0.2,
      "acetateOpacity": 0.96,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b49b95",
      "lensOpacity": 0.3,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.66,
        0.52,
        0.48
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-rose-radiance-front.jpg", import.meta.url).href
  },
  {
    "id": "velvet-hamme",
    "model": "Velvet Noir",
    "colorway": "Black",
    "line": "Handmade",
    "productHandle": "velvet-hamme",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 54,
      "bridgeMm": 17,
      "templeMm": 145,
      "lensHeightMm": 37.6795,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 1,
      "topInsetMm": 0,
      "topAtHingeMm": 20.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#262629",
      "acetateRoughness": 0.48,
      "acetateOpacity": 1,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#729bdc",
      "lensOpacity": 0.25,
      "lensMirror": 0.005,
      "lensTransmission": [
        0.59,
        0.72,
        0.91
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-velvet-hamme-front.jpg", import.meta.url).href
  },
  {
    "id": "velvet-hamme-1",
    "model": "Velvet Noir",
    "colorway": "Violet",
    "line": "Handmade",
    "productHandle": "velvet-hamme-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 54,
      "bridgeMm": 17,
      "templeMm": 145,
      "lensHeightMm": 38.0808,
      "frontDepthMm": 5,
      "endPieceDepthMm": 5
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 1,
      "topInsetMm": 0,
      "topAtHingeMm": 22.3,
      "hingeInsetMm": 3.2,
      "outerInsetMm": 1,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#69299c",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.84,
      "acetatePhotoOpacity": 0.95,
      "rivetLengthMm": 0,
      "lensColor": "#b365a2",
      "lensOpacity": 0.3,
      "lensMirror": 0.005,
      "lensTransmission": [
        0.81,
        0.48,
        0.7
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-velvet-hamme-1-front.jpg", import.meta.url).href
  },
  {
    "id": "shindig-3",
    "model": "Shindig",
    "colorway": "Crystal Brown",
    "line": "Handmade",
    "productHandle": "shindig-3",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 34,
      "templeMm": 145,
      "lensHeightMm": 35.8238,
      "frontDepthMm": 4,
      "endPieceDepthMm": 4
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#743c21",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.9,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#c29e96",
      "lensOpacity": 0.18,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.88,
        0.74,
        0.7
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-shindig-3-front.jpg", import.meta.url).href
  },
  {
    "id": "shindig-2",
    "model": "Shindig",
    "colorway": "Crystal Blue & Tortoise",
    "line": "Handmade",
    "productHandle": "shindig-2",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 34,
      "templeMm": 145,
      "lensHeightMm": 34.6479,
      "frontDepthMm": 4,
      "endPieceDepthMm": 4
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#075490",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.9,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#478acc",
      "lensOpacity": 0.32,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.35,
        0.62,
        0.88
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-shindig-2-front.jpg", import.meta.url).href
  },
  {
    "id": "shindig-copy",
    "model": "Shindig",
    "colorway": "Tortoise & Yellow",
    "line": "Handmade",
    "productHandle": "shindig-copy",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 34,
      "templeMm": 145,
      "lensHeightMm": 34.8804,
      "frontDepthMm": 4,
      "endPieceDepthMm": 4
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#33271c",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.98,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#4c4958",
      "lensOpacity": 0.6,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.23,
        0.22,
        0.28
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-shindig-copy-front.jpg", import.meta.url).href
  },
  {
    "id": "shindig-1",
    "model": "Shindig",
    "colorway": "Smoke & White",
    "line": "Handmade",
    "productHandle": "shindig-1",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 34,
      "templeMm": 145,
      "lensHeightMm": 34.6964,
      "frontDepthMm": 4,
      "endPieceDepthMm": 4
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#282832",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#4c4958",
      "lensOpacity": 0.36,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.46,
        0.44,
        0.5
      ],
      "lensGradient": 0.55
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-shindig-1-front.jpg", import.meta.url).href
  },
  {
    "id": "shindig",
    "model": "Shindig",
    "colorway": "Tortoise & White Marble",
    "line": "Handmade",
    "productHandle": "shindig",
    "customizable": true,
    "dims": {
      "widthMm": 145,
      "lensWidthMm": 36,
      "bridgeMm": 34,
      "templeMm": 145,
      "lensHeightMm": 34.4892,
      "frontDepthMm": 4,
      "endPieceDepthMm": 4
    },
    "temple": {
      "widthMm": 4,
      "tipWidthRatio": 0.7,
      "topInsetMm": 0.7,
      "topAtHingeMm": 10,
      "hingeInsetMm": 3,
      "outerInsetMm": 0.4,
      "profileStartMm": 0,
      "profileMode": "measured"
    },
    "fit": {
      "pantoscopicTiltDeg": 6,
      "anchorOffsetYMm": -1,
      "vertexDistanceMm": 13,
      "hingeToEarMm": 100
    },
    "look": {
      "acetateColor": "#65351b",
      "acetateRoughness": 0.18,
      "acetateOpacity": 0.88,
      "acetatePhotoOpacity": 1,
      "rivetLengthMm": 0,
      "lensColor": "#b34c46",
      "lensOpacity": 0.4,
      "lensMirror": 0.01,
      "lensTransmission": [
        0.76,
        0.28,
        0.24
      ],
      "lensGradient": 0
    },
    "thumbnail": new URL("../../../assets-source/derived/mata-shindig-front.jpg", import.meta.url).href
  }
];
